import { useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { STAGE_CFG, CLOSED_STAGES } from "./constants";
import { S, Ic } from "./ui";
import KanbanCard from "./KanbanCard";

export default function KanbanColumn({ stage, opps, onCardClick, onCreateNew, onEditOpp, onDeleteOpp, onArchiveOpp }) {
  const [collapsed, setCollapsed] = useState(false);
  const { setNodeRef, isOver } = useDroppable({
    id: stage,
  });

  const c = STAGE_CFG[stage] || { accent: "#999", bg: "#f5f5f5", text: "#555" };
  const isClosed = CLOSED_STAGES.includes(stage);
  const total  = opps.reduce((s, o) => s + (o.amount || 0), 0);
  const totalK = total >= 1000 ? (total / 1000).toFixed(1) + "k" : total.toLocaleString();

  if (collapsed) {
    return (
      <div 
        ref={setNodeRef} // Make collapsed column droppable too
        onClick={() => setCollapsed(false)} title={`Expand ${stage}`}
        style={{ width: "38px", flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", paddingTop: "10px", cursor: "pointer", background: isOver ? "#eef" : "transparent" }}>
        <div style={{ width: "32px", height: "32px", borderRadius: "8px", background: c.bg, display: "flex", alignItems: "center", justifyContent: "center", border: `1.5px solid ${c.accent}30` }}>
          <span style={{ fontSize: "11px", fontWeight: "700", color: c.accent }}>{opps.length}</span>
        </div>
        <span style={{ writingMode: "vertical-rl", fontSize: "10px", fontWeight: "700", color: c.accent, letterSpacing: "0.5px", userSelect: "none" }}>{stage}</span>
      </div>
    );
  }

  return (
    <div 
      ref={setNodeRef}
      style={{ display: "flex", flexDirection: "column", width: "210px", minWidth: "210px", flexShrink: 0, background: isOver ? "#eef" : "transparent", borderRadius: "10px", transition: "background .2s" }}>
      {/* Header */}
      <div style={{ padding: "7px 9px", borderRadius: "10px 10px 0 0", background: c.bg, borderBottom: `2px solid ${c.accent}25`, minHeight: "46px" }}>
        <div style={{ ...S.row(0), justifyContent: "space-between", marginBottom: "2px" }}>
          <div style={S.row(5)}>
            <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: c.accent, flexShrink: 0 }} />
            <span style={{ fontSize: "10.5px", fontWeight: "700", color: c.accent }}>{stage}</span>
            <span style={{ minWidth: "16px", height: "16px", borderRadius: "8px", background: c.accent + "30", color: c.accent, fontSize: "9.5px", fontWeight: "700", display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>
              {opps.length}
            </span>
            {isClosed && (
              <span style={{ fontSize: "8px", background: c.accent + "20", color: c.accent, borderRadius: "4px", padding: "1px 4px", fontWeight: "700" }}>Closed</span>
            )}
          </div>
          <div style={S.row(1)}>
            <button onClick={() => setCollapsed(true)} style={{ width: "18px", height: "18px", border: "none", background: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: c.accent + "70", borderRadius: "3px" }}>
              <Ic n="collapse" s={9} />
            </button>
            {!isClosed && (
              <button onClick={onCreateNew} style={{ width: "18px", height: "18px", border: "none", background: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: c.accent + "70", borderRadius: "3px" }}>
                <Ic n="plus" s={9} />
              </button>
            )}
          </div>
        </div>
        <div style={{ paddingLeft: "11px", fontSize: "9.5px", color: c.accent + "90", fontWeight: "500" }}>
          {total > 0 && `$${totalK}`}
        </div>
      </div>

      {/* Cards */}
      <div style={{ flex: 1, background: "#f4f4f9", borderRadius: "0 0 10px 10px", padding: "6px", overflowY: "auto", minHeight: "50px", maxHeight: "calc(100vh - 215px)" }}>
        {opps.map(o => (
          <KanbanCard key={o.id} opp={o} onClick={onCardClick} onEdit={onEditOpp} onDelete={onDeleteOpp} onArchive={onArchiveOpp} />
        ))}
        {!isClosed && (
          <button onClick={onCreateNew}
            style={{ width: "100%", padding: "6px", border: "1.5px dashed #c8c8e0", borderRadius: "8px", background: "transparent", cursor: "pointer", fontSize: "10.5px", color: "#9e9eb8", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", transition: "all .15s", marginTop: "2px" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = c.accent; e.currentTarget.style.color = c.accent; e.currentTarget.style.background = c.bg; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#c8c8e0"; e.currentTarget.style.color = "#9e9eb8"; e.currentTarget.style.background = "transparent"; }}
          >
            <Ic n="plus" s={9} /> Add
          </button>
        )}
      </div>
    </div>
  );
}
